// Página Cart - Carrito de compras
// Muestra todos los productos agregados al carrito con opciones para modificar cantidades y eliminar

import { Link } from 'react-router-dom'
import { useCart } from '../hooks/useCart'
import Button from '../components/Button'
import CartItem from '../components/CartItem'
import CartSummary from '../components/CartSummary'
import './Cart.css'

/**
 * Página Cart
 * Muestra el carrito de compras con todos los productos agregados
 */
function Cart() {
  const { cartItems, clearCart, getCartItemCount } = useCart()

  // Si el carrito está vacío, mostrar mensaje
  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <div className="cart-container">
          <div className="cart-empty">
            <div className="empty-cart-icon">🛒</div>
            <h2>Tu carrito está vacío</h2>
            <p>Agrega productos desde el catálogo para comenzar a comprar</p>
            <Link to="/productos">
              <Button variant="primary">
                Ver Productos
              </Button>
            </Link>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="cart-page">
      <div className="cart-container">
        {/* Header del carrito */}
        <div className="cart-header">
          <h1 className="cart-title">Carrito de Compras</h1>
          <p className="cart-subtitle">
            {getCartItemCount()} {getCartItemCount() === 1 ? 'producto' : 'productos'} en tu carrito
          </p>
        </div>

        {/* Contenido principal: Lista de productos y resumen */}
        <div className="cart-content">
          {/* Lista de productos */}
          <div className="cart-items-section">
            <div className="cart-items-header">
              <h2>Productos</h2>
              <button
                className="clear-cart-btn"
                onClick={clearCart}
                aria-label="Vaciar carrito"
              >
                Vaciar carrito
              </button>
            </div>

            <div className="cart-items-list">
              {cartItems.map((item) => (
                <CartItem key={item.id} item={item} />
              ))}
            </div>

            {/* Botón para continuar comprando */}
            <div className="cart-continue-shopping">
              <Link to="/productos">
                <Button variant="outline">
                  ← Continuar Comprando
                </Button>
              </Link>
            </div>
          </div>

          {/* Resumen del pedido */}
          <div className="cart-summary-section">
            <CartSummary />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Cart

